import { createContext } from 'react';

export const ProducerDashboardFeedbacksContext = createContext(0);
